import axios from "axios";

export default {
  namespaced: true,
  state: {
    date: "",
    timeslot: "",
    court: [],
    price: "",
    addons1: [],
    addons2: [],
    billing: "",
    multiaddons1: [],
    multiaddons2: [],
    filtercourt: [],
    inv: "",
    paymentlink: "",
  },
  getters: {
    date(state) {
      return state.date;
    },
    timeslot(state) {
      return state.timeslot;
    },
    court(state) {
      return state.court;
    },
    price(state) {
      return state.price;
    },
    addons1(state) {
      return state.addons1;
    },
    addons2(state) {
      return state.addons2;
    },
    billing(state) {
      return state.billing;
    },
    multiaddons1(state) {
      return state.multiaddons1;
    },
    multiaddons2(state) {
      return state.multiaddons2;
    },
    filtercourt(state) {
      return state.filtercourt;
    },
    inv(state) {
      return state.inv;
    },
    paymentlink(state) {
      return state.paymentlink;
    },
  },
  mutations: {
    SET_DATE(state, value) {
      state.date = value;
    },
    SET_TIMESLOT(state, value) {
      state.timeslot = value;
    },
    SET_COURT(state, value) {
      state.court = value;
    },
    SET_PRICE(state, value) {
      state.price = value;
    },
    SET_ADDONS1(state, value) {
      // state.addons1.push(value)
      state.addons1 = value;
    },
    SET_ADDONS2(state, value) {
      // state.addons2.push(value)
      state.addons2 = value;
    },
    SET_BILLING(state, value) {
      state.billing = value;
    },
    SET_MULTIADDONS1(state, value) {
      if (value[0].addon.length > 0) {
        if (state.multiaddons1.length > 0) {
          var tempAddon = state.multiaddons1.filter(
            (item) => item.date != value[0].date
          );
          state.multiaddons1 = [...tempAddon, ...value];
        } else {
          state.multiaddons1 = value;
        }
      } else {
        var tempAddonEmpty = state.multiaddons1.filter(
          (item) => item.date != value[0].date
        );
        state.multiaddons1 = tempAddonEmpty;
      }
    },
    SET_MULTIADDONS2(state, value) {
      if (value[0].addon.length > 0) {
        if (state.multiaddons2.length > 0) {
          var tempAddon = state.multiaddons2.filter(
            (item) => item.date != value[0].date
          );
          state.multiaddons2 = [...tempAddon, ...value];
        } else {
          state.multiaddons2 = value;
        }
      } else {
        var tempAddonEmpty = state.multiaddons2.filter(
          (item) => item.date != value[0].date
        );
        state.multiaddons2 = tempAddonEmpty;
      }
    },
    SET_FILTERCOURT(state, value) {
      state.filtercourt = value;
    },
    SET_RESET(state, value) {
      state.addons1 = value;
      state.addons2 = value;
      state.multiaddons1 = value;
      state.multiaddons2 = value;
    },
    SET_INV(state, value) {
      state.inv = value;
    },
    SET_PAYMENTLINK(state, value) {
      state.paymentlink = value;
    },
  },
  actions: {
    date({ commit }, { set_date }) {
      commit("SET_DATE", set_date);
    },
    timeslot({ commit }, { set_timeslot }) {
      commit("SET_TIMESLOT", set_timeslot);
    },
    court({ commit }, { set_court }) {
      commit("SET_COURT", set_court);
    },
    price({ commit }, { set_price }) {
      commit("SET_PRICE", set_price);
    },
    addons1({ commit }, { set_addons1 }) {
      commit("SET_ADDONS1", set_addons1);
    },
    addons2({ commit }, { set_addons2 }) {
      commit("SET_ADDONS2", set_addons2);
    },
    billing({ commit }, { set_billing }) {
      commit("SET_BILLING", set_billing);
    },
    multiaddons1({ commit }, { set_multiaddons1 }) {
      commit("SET_MULTIADDONS1", set_multiaddons1);
    },
    multiaddons2({ commit }, { set_multiaddons2 }) {
      commit("SET_MULTIADDONS2", set_multiaddons2);
    },
    inv({ commit }, { set_inv }) {
      commit("SET_INV", set_inv);
    },
    paymentlink({ commit }, { set_paymentlink }) {
      commit("SET_PAYMENTLINK", set_paymentlink);
    },
    async filtercourt({ commit }, { court, timeslot }) {
      try {
        const response = await axios.get(
          `/api/frontend/schedule-courts/${court}/${timeslot}`
        );
        // console.log('type', typeof response.data);
        // console.log('data', response.data);
        commit("SET_FILTERCOURT", response.data);
      } catch (error) {
        console.error(error);
        commit("SET_FILTERCOURT", []);
      }
    },
    reset_data({ commit }) {
      commit("SET_DATE", "");
      commit("SET_TIMESLOT", "");
      commit("SET_COURT", []);
      commit("SET_PRICE", "");
      commit("SET_ADDONS1", []);
      commit("SET_ADDONS2", []);
      commit("SET_BILLING", "");
      commit("SET_FILTERCOURT", []);
    },
    reset_data_guest({ commit }) {
      commit("SET_INV", "");
      commit("SET_PAYMENTLINK", "");
    },
    reset_all_addons({ commit }) {
      commit("SET_RESET", []);
    },
  },
};
